module.exports = __webpack_public_path__ + "img/login_slide_05.65dc16e1.webp";